export { default } from './SWRelatedProducts';
